import ApiService from './ApiService';
import UtilsService from './UtilsService';
import { bundleQueries } from '../queries/bundle.queries';
import store from '@/store';

export const getBundle = () => {
  const query = bundleQueries.getSMSBundle(store.state.auth.currentUser.retailer.objectId);
  return ApiService.get(UtilsService.buildFullPath(query)).then(
    (res) => {
      if (res && res.length > 1) {
        let higherPriority = 0;
        let higherPriorityBundle = null;
        res.results.forEach((bundle: any) => {
          if (bundle.priority > higherPriority) {
            higherPriority = bundle.priority;
            higherPriorityBundle = bundle;
          }
        });
        return higherPriorityBundle;
      } else if (res) {
        return res.results[0];
      }
      return null;
    },
  );
};
